import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Treatments", href: "#treatments", testid: "nav-treatments-link" },
  { label: "Patient Journey", href: "#journey", testid: "nav-journey-link" },
  { label: "Stories", href: "#stories", testid: "nav-stories-link" },
];

const scrollTo = (e, href) => {
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="mt-4 flex items-center justify-between rounded-full border border-sand bg-ivory/85 backdrop-blur-xl px-5 py-3 shadow-[0_8px_30px_rgba(8,61,52,0.08)]">
          <a href="#top" onClick={(e) => scrollTo(e, "#top")} data-testid="nav-logo" className="font-serif text-2xl font-semibold tracking-tight text-brand-green">
            OravioCare
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.testid}
                onClick={(e) => scrollTo(e, l.href)}
                className="text-sm font-medium text-ash transition-colors duration-300 hover:text-brand-green"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="#quote"
              data-testid="nav-quote-btn"
              onClick={(e) => scrollTo(e, "#quote")}
              className="rounded-full bg-brand-green px-5 py-2.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:bg-brand-glow"
            >
              Get Free Quote
            </a>
          </div>

          <button
            data-testid="nav-mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-brand-green"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden mx-4 mt-2 rounded-2xl border border-sand bg-ivory p-6 shadow-xl"
          >
            <div className="flex flex-col gap-4">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`mobile-${l.testid}`}
                  onClick={(e) => { scrollTo(e, l.href); setOpen(false); }}
                  className="text-base font-medium text-ink"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#quote"
                data-testid="mobile-nav-quote-btn"
                onClick={(e) => { scrollTo(e, "#quote"); setOpen(false); }}
                className="mt-2 rounded-full bg-brand-green px-5 py-3 text-center text-sm font-semibold text-ivory"
              >
                Get Free Quote
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
